// extracted by mini-css-extract-plugin
module.exports = {"faqs":"SectionFaq_faqs__Vao0r","faqs__title":"SectionFaq_faqs__title__F7q8K","faqs__container":"SectionFaq_faqs__container__ijw0B"};